import { useEffect, useState } from "react";

// 0022: value-debounce. Returns `value` only after it has stayed unchanged for
// `delay` ms; a later change before the timer fires resets the wait. When `delay`
// is 0 the value updates immediately (used for instant clear on an empty search,
// so emptying the box snaps back to the default view with no delay). Mirrors
// useDelayedFlag.js's setTimeout + cleanup shape — no external dependency.
const useDebounce = (value, delay = 350) => {
  const [debounced, setDebounced] = useState(value);

  useEffect(() => {
    if (delay === 0) {
      setDebounced(value);
      return undefined;
    }
    const id = setTimeout(() => setDebounced(value), delay);
    return () => clearTimeout(id);
  }, [value, delay]);

  return debounced;
};

export default useDebounce;
